import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import apiProvider from '../apiProvider/api';
import apiProvider from '../apiProvider/api';
import { IMAGE_URL } from '../../src/network/apiClient'
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
const ItemsPerPage = 10; // Number of items per page


const CategoryPageLayer = () => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [formErrors, setFormErrors] = useState({});


    const [formData, setFormData] = useState({
        categoryType: "1",
        categoryName: "",
        categoryStatus: "Active",
        categorySlug: "",
        categoryImage: null,
    });
    const [categoryData, setCategoryData] = useState([]);


    const fetchData = async () => {
        try {
            const result = await apiProvider.getCategory();
            console.log(result, "result");
            if (result) {
                setCategoryData(result.response.data.data);
            }
        } catch (error) {
            console.error("Error fetching category data:", error);
        }
    };


    useEffect(() => {
        fetchData();
    }, []); // Empty dependency array means this runs once on mount

    // Function to determine category type name
    const getCategoryTypeName = (type) => {
        return type === '1' ? 'Online' : 'Offline'; // Adjust as needed based on your actual types
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        // if (e.target.files && e.target.files.length > 0) {
        //     setFormData((prev) => ({
        //         ...prev,
        //         categoryImage: e.target.files[0],
        //     }));
        // }
        const file = e.target.files[0];

        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                alert('Only JPG and PNG image formats are allowed.');
                e.target.value = ""; // Clear the input
                return;
            }

            setFormData((prev) => ({
                ...prev,
                categoryImage: file,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = {};

        if (!formData.categoryName) errors.categoryName = "Category name is required.";
        if (!formData.categoryImage && !isEditMode) errors.categoryImage = "Image is required.";

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        console.log("Form submitted:", formData);

        const input = new FormData();
        input.append("categoryType", formData.categoryType);
        input.append("categoryName", formData.categoryName);
        input.append("categoryStatus", formData.categoryStatus);
        input.append("categorySlug", formData.categorySlug);

        // Only append image if it's a new file (not a string path)
        if (formData.categoryImage instanceof File) {
            input.append("categoryImage", formData.categoryImage);
        } else if (typeof formData.categoryImage === 'string') {
            // If it's a string (existing image path), you might want to handle differently
            input.append("categoryImagePath", formData.categoryImage);
        }

        console.log(...input, "input");

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", formData.id);
                response = await apiProvider.updateCategory(input);
            } else {
                // For create mode
                response = await apiProvider.addCategory(input);
            }

            console.log(response, "response");

            if (response) {
                // const notify = () => toast("Wow so easy!");
                // Reset form
                toast(response.response.data.message)
                setFormData({
                    categoryType: "1", // Changed from "online" to "1" to match your select values
                    categoryName: "",
                    categoryStatus: "Active", // Changed to lowercase to match your select values
                    categorySlug: "",
                    categoryImage: ""

                });
                const input = document.getElementById("categoryImage");
                if (input) input.value = "";
                // ✅ Clear previous errors if validation passes
                setFormErrors({});

                // Refresh data
                fetchData();

                // Reset edit mode
                setIsEditMode(false);
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000)
                // Remove modal styles and backdrop manually
                const backdrop = document.querySelector(".modal-backdrop");
                const modal = document.getElementById("exampleModalEdit");

                if (modal) {
                    modal.classList.remove("show");
                    modal.classList.remove("d-block");
                    modal.setAttribute("aria-hidden", "true");
                    modal.style.display = "none";
                }

                if (backdrop) {
                    backdrop.remove();
                }

                document.body.classList.remove("modal-open");
                document.body.style.overflow = "auto"; // 
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
    };

    const handleEditClick = (category) => {
        setIsEditMode(true);
        setFormData({
            id: category.id,
            categoryType: category.categoryType,
            categoryName: category.categoryName,
            categoryStatus: category.categoryStatus,
            categorySlug: category.categorySlug,
            categoryImage: category.categoryImage
        });
        ;
    };



    const handleDelete = async (category) => {
        console.log(category, "ccccccccc");

        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete "${category.categoryName}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                title: 'swal-title-small',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // 👇 Call your delete API or logic here
                const result = await apiProvider.deletCategory(category.id);
                console.log(result, "rrrrrrrrrrrr");
                if (result) {
                    deleteCategory(category.id);
                }



            }
        });
    };

    // Example delete function (you should replace this with your actual API call)
    const deleteCategory = async (id) => {
        try {
            // await your API delete call
            console.log("Deleting category with ID:", id);

            Swal.fire(
                'Deleted!',
                'Category has been deleted.',
                'success'
            );
            // Refresh data
            fetchData();

            // Optionally refresh the list or update UI
        } catch (error) {
            Swal.fire(
                'Error!',
                'There was a problem deleting the category.',
                'error'
            );
        }
    };


    // Calculate total pages
    const totalPages = Math.ceil(categoryData.length / ItemsPerPage);

    // Get the current page's data
    const startIndex = (currentPage - 1) * ItemsPerPage;
    const endIndex = startIndex + ItemsPerPage;
    const currentData = categoryData.slice(startIndex, endIndex);

    // Handle page change
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
                <div></div>
                <div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalEdit"
                        onClick={() => {
                            setFormData({
                                categoryType: "1",
                                categoryName: "",
                                categoryStatus: "Active",
                                categorySlug: "",
                                categoryImage: null
                            });
                            const input = document.getElementById("categoryImage");
                            if (input) input.value = "";
                        }}
                    >
                        {/* <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        /> */}
                        Add Category Form
                    </button>
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Category Type</th>
                                <th scope="col">Category Name</th>
                                <th scope="col">Category Status</th>
                                {/* <th scope="col">Category Slug</th> */}
                                <th scope="col" >Category Image</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((category, index) => (
                                <tr key={category.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-10">

                                            {index + 1}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                                    {getCategoryTypeName(category.categoryType)}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.categoryName}
                                        </span>
                                    </td>
                                    <td className="text-center">
                                        <span className={`${category.categoryStatus === 'Active'
                                            ? 'bg-success-focus text-success-600 border border-success-main'
                                            : 'bg-danger-focus text-danger-600 border border-danger-main'} 
                px-24 py-4 radius-4 fw-medium text-sm`}>
                                            {category && category.categoryStatus && category.categoryStatus.charAt(0).toUpperCase() + category.categoryStatus.slice(1)}
                                        </span>
                                    </td>
                                    {/* <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.categorySlug}
                                        </span>
                                    </td> */}
                                    <td>
                                        {/* - */}
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {category.categoryImage ? (
                                                <img
                                                    src={IMAGE_URL + category.categoryImage}
                                                    alt="Category"
                                                    className="img-thumbnail"
                                                    style={{ width: '50px', height: '50px' }}
                                                />
                                            ) : 'No Image'}
                                        </span>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {/* <button
                                                type="button"
                                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                            >
                                                <Icon
                                                    icon="majesticons:eye-line"
                                                    className="icon text-xl"
                                                />
                                            </button> */}
                                            <button
                                                type="button"
                                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModalEdit"
                                                onClick={() => handleEditClick(category)}
                                            >
                                                <Icon icon="lucide:edit" className="menu-icon" />
                                            </button>
                                            <button
                                                type="button"
                                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                onClick={() => handleDelete(category)}
                                            >
                                                <Icon
                                                    icon="fluent:delete-24-regular"
                                                    className="menu-icon"
                                                />

                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>
                            Showing {startIndex + 1} to {Math.min(endIndex, categoryData.length)} of {categoryData.length} entries
                        </span>
                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <Icon icon="ep:d-arrow-left" />
                                </Link>
                            </li>

                            {/* Page Numbers */}
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className="page-item">
                                    <Link
                                        className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200 text-secondary-light"
                                            }`}
                                        to="#"
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </Link>
                                </li>
                            ))}

                            {/* Next Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <Icon icon="ep:d-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
            </div>

            {/* add course type model */}
            <div
                className="modal fade"
                id="exampleModalEdit"
                // tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
                tabindex="-1" role="dialog"
            >
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                {/* <h1 className="modal-title fs-5"> */}
                                {isEditMode ? 'Edit Category' : 'Add New Category'}
                                {/* </h1> */}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Category Type</label>
                                        <select
                                            className="form-select"
                                            name="categoryType"
                                            value={formData.categoryType}
                                            onChange={handleChange}
                                        >
                                            <option value="1">Online</option>
                                            <option value="2">Offline</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Category Name</label>
                                        <input
                                            type="text"
                                            name="categoryName"
                                            className="form-control"
                                            value={formData.categoryName}
                                            onChange={handleChange}
                                        />
                                        {formErrors.categoryName && (
                                            <div className="text-danger small mt-1">{formErrors.categoryName}</div>
                                        )}

                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Category Status</label>
                                        <select
                                            className="form-select"
                                            name="categoryStatus"
                                            value={formData.categoryStatus}
                                            onChange={handleChange}
                                        >
                                            <option value="Active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Category Slug</label>
                                        <input
                                            type="text"
                                            name="categorySlug"
                                            className="form-control"
                                            value={formData.categorySlug}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Image</label>
                                        <input
                                            className="form-control form-control-sm"
                                            name="categoryImage"
                                            type="file"
                                            id="categoryImage"
                                            accept="image/png, image/jpeg"
                                            onChange={handleFileChange}
                                            style={{ height: "45px" }}
                                        />
                                        {formErrors.categoryImage && (
                                            <div className="text-danger small mt-1">{formErrors.categoryImage}</div>
                                        )}

                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {isEditMode && formData.categoryImage ? (
                                                <img
                                                    src={IMAGE_URL + formData.categoryImage}
                                                    alt="Category"
                                                    className="img-thumbnail"
                                                    style={{ width: '50px', height: '50px' }}
                                                />
                                            ) : ''}
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary text-sm">
                                            {isEditMode ? 'Update' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            {/* add category model */}
            <ToastContainer />

        </div>


    )
}

export default CategoryPageLayer